import { render, staticRenderFns } from "./CombatPVP.vue?vue&type=template&id=efd96ec4&scoped=true&"
import script from "./CombatPVP.vue?vue&type=script&lang=js&"
export * from "./CombatPVP.vue?vue&type=script&lang=js&"
import style0 from "./CombatPVP.vue?vue&type=style&index=0&id=efd96ec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd96ec4",
  null
  
)

export default component.exports